import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IAd } from 'services/rtk/fbmanager/types/ad';

import { QueryFilter, AccountFilter } from './types';

export interface FBCommentsState {
  filters: {
    queryFilter: QueryFilter;
    accountFilter: AccountFilter;
  };
  search: string;
  shouldShowSpinner: boolean;
  adModal: {
    ad?: Partial<IAd>;
    isOpen: boolean;
  };
}

const initialState: FBCommentsState = {
  filters: {
    queryFilter: {
      query: undefined,
    },
    accountFilter: {
      accountId: undefined,
    },
  },
  search: '',
  shouldShowSpinner: true,
  adModal: {
    ad: undefined,
    isOpen: false,
  },
};

export const fbCommentsSlice = createSlice({
  name: 'fbcomments',
  initialState,
  reducers: {
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    resetSearchQuery: (state) => {
      state.search = '';
    },
    updateAccountFilter: (state, action: PayloadAction<number>) => {
      state.filters.accountFilter.accountId = action.payload;
    },
    resetAccountFilter: (state) => {
      state.filters.accountFilter = initialState.filters.accountFilter;
    },
    updateQueryFilter: (state, action: PayloadAction<Partial<QueryFilter>>) => {
      state.filters.queryFilter = { ...state.filters.queryFilter, ...action.payload };
    },
    resetQueryFilter: (state) => {
      state.filters.queryFilter = initialState.filters.queryFilter;
    },
    setShowingSpinner: (state, action: PayloadAction<boolean>) => {
      state.shouldShowSpinner = action.payload;
    },
    setAdModalState: (state, action: PayloadAction<boolean>) => {
      state.adModal.isOpen = action.payload;
    },
    setAdModalCurrentAd: (state, action: PayloadAction<Partial<IAd>>) => {
      state.adModal.ad = action.payload;
    },
  },
});

export const fbCommentsReducer = fbCommentsSlice.reducer;

export const {
  setSearchQuery,
  resetSearchQuery,
  updateAccountFilter,
  resetAccountFilter,
  updateQueryFilter,
  resetQueryFilter,
  setShowingSpinner,
  setAdModalState,
  setAdModalCurrentAd,
} = fbCommentsSlice.actions;
